import { getGlobal, noStorageSupport } from "../lib/get-global";
import { generateRandomString } from "../lib/random";
import { MetadataPlugin } from "./metadata";

export const createPersistentIdPlugin: MetadataPlugin<string> = function () {
  const globalThis = getGlobal();

  if (
    noStorageSupport(globalThis)
  ) {
    return {
      getValue() {
        return {};
      },
    };
  }

  const PERSISTENT_ID_KEY = "spindl_persistent_id";

  let persistentId = globalThis.localStorage.getItem(PERSISTENT_ID_KEY) || "";

  if (!persistentId) {
    persistentId = generateRandomString();
    globalThis.localStorage.setItem(PERSISTENT_ID_KEY, persistentId);
  }

  function getValue() {
    return { persistentId };
  }

  return {
    getValue,
  };
};
